import { Box, Typography } from "@mui/material";
import iconMapping from "../../../icons/IconMapping";
import SvgToIcon from "../../../icons/SvgToIcon";

export const FooterScenario = ({ notification }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "row",
      gap: "8px",
      alignItems: "center",
      cursor: "pointer",
    }}
  >
    <SvgToIcon
      IconLogo={iconMapping[notification.icon_name]}
      style={{
        width: "16px",
        height: "16px",
      }}
    />

    <Typography variant="caption">{notification.label}</Typography>
  </Box>
);
